import React from 'react';

import {
  RATING_LIMITS,
  RATING_SHAPES,
  RatingConfig,
} from '../../CustomBlocks/scale/scaleTypes';
import {
  NumberStepper,
  SegmentedControl,
  SettingsGroup,
  SettingsRow,
  Switch,
} from '../slotBookingEditor/settingsUi';
import { TextSetting } from '../quizBlocksEditor/quizEditorUi';

interface RatingEditorProps {
  config: RatingConfig;
  onChange: (patch: Partial<RatingConfig>) => void;
}

const RatingEditor: React.FC<RatingEditorProps> = ({ config, onChange }) => (
  <>
    <SettingsGroup title="Rating">
      <SettingsRow label="Shape" stacked>
        <SegmentedControl
          value={config.shape}
          options={RATING_SHAPES}
          onChange={(shape) => onChange({ shape })}
        />
      </SettingsRow>
      <SettingsRow label="Number of points">
        <NumberStepper
          value={config.count}
          min={RATING_LIMITS.min}
          max={RATING_LIMITS.max}
          step={1}
          unit="pts"
          label="Number of points"
          onChange={(count) => onChange({ count })}
        />
      </SettingsRow>
    </SettingsGroup>

    <SettingsGroup title="Labels" footer="Optional text under the lowest and highest point.">
      <TextSetting
        label="Lowest"
        placeholder="e.g. Poor"
        value={config.lowLabel}
        onChange={(lowLabel) => onChange({ lowLabel })}
      />
      <TextSetting
        label="Highest"
        placeholder="e.g. Excellent"
        value={config.highLabel}
        onChange={(highLabel) => onChange({ highLabel })}
      />
    </SettingsGroup>

    <SettingsGroup footer="Multi-step forms only. Works best when this is the only question on its step.">
      <SettingsRow label="Go to next step on pick">
        <Switch
          checked={config.autoAdvance}
          label="Go to next step on pick"
          onChange={(autoAdvance) => onChange({ autoAdvance })}
        />
      </SettingsRow>
    </SettingsGroup>
  </>
);

export default RatingEditor;
